
<div class="row" *ngIf="hashInvitation">
  <div class="col-sm-12">
    <h2 *ngIf="!accepted" >Aceptar invitación VisorCUE Entidades</h2>
    <h2 *ngIf="accepted" >Invitación aceptada</h2>
    <p *ngIf="!accepted" >Inicie sesión para aceptar la invitación</p>
    <p *ngIf="accepted" >Ya puede cerrar esta ventana</p>
  </div>
</div>

<!-- Estado de verificación de email -->
<div *ngIf="isVerifyingEmail" class="verification-container">
  <div class="spinner"></div>
  <h2>Verificando tu email...</h2>
  <p>Por favor espera mientras procesamos la verificación de tu email.</p>
</div>

<!-- Login normal -->
<div *ngIf="!isVerifyingEmail">
  <h1>VisorCUE</h1>
  <div id="firebaseui-auth-container"></div>
</div>